import { Field } from './field';
import { Template } from '@/shared/dtos/template';
import { ItiBaseDto } from "@/iti-core-vue";

export class TemplateVersion extends ItiBaseDto{
    public description!: string;
    public version!: number;
    public active!: boolean;
    public published!: boolean;
    public templateId!: number;
    public fields!: Field[];
}